// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/Home.vue';
import Prinress from '@/views/Princess.vue';
import About from '@/views/About.vue';
import Contact from '@/views/Contact.vue';
// import Vip from '@/views/Vip.vue';
import Recuruiment from '@/views/Recuruiment.vue';
import Product from '@/views/Product.vue';
import Review from '@/views/Wellreceived.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { 
      cached: true,
        title:'西雅图桃桃私人会所-首页',
        keywords:'西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所',
        description:'西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所,西雅图桃桃私人会所是西雅图私人高级会所之一,你都可以在我们的网站找到你想要的享受。'
     }, // 设置此页面需要缓存
  },
  {
    path: '/prinress',
    name: 'Prinress',
    component: Prinress,
    meta: {  
        title:'西雅图桃桃私人会所-公主',
        keywords:'西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所',
        description:'西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所,西雅图桃桃私人会所是西雅图私人高级会所之一,你都可以在我们的网站找到你想要的享受。'
     }, // 设置此页面需要缓存
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
    meta: {  
        title:'西雅图桃桃私人会所-联系方式',
        keywords:'西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所',
        description:'西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所,西雅图桃桃私人会所是西雅图私人高级会所之一,你都可以在我们的网站找到你想要的享受。'
     },
  }, 
  {
    path: '/about',
    name: 'about',
    component: About,
    meta: {  
        title:'西雅图桃桃私人会所-服务介绍',
        keywords:'西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所',
        description:'西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所,西雅图桃桃私人会所是西雅图私人高级会所之一,你都可以在我们的网站找到你想要的享受。'
     },
  },
  {
    path: '/recuruiment',
    name: 'recuruiment',
    component: Recuruiment,
    meta: {   
        title:'西雅图桃桃私人会所-招聘合作',
        keywords:'西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所',
        description:'西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所,西雅图桃桃私人会所是西雅图私人高级会所之一,你都可以在我们的网站找到你想要的享受。'
     },
  },
//   {
//     path: '/vip',
//     name: 'vip',
//     component: Vip,
//     meta: {   
//         title:'西雅图桃桃私人会所-VIP',
//         keywords:'西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所',
//         description:'西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所,西雅图桃桃私人会所是西雅图私人高级会所之一,你都可以在我们的网站找到你想要的享受。'
//      },
//   },
  {
    path: '/product',
    name: 'Product',
    component: Product,
    meta: {   
        title:'西雅图桃桃私人会所-公主',
        keywords:'西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所',
        description:'西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所,西雅图桃桃私人会所是西雅图私人高级会所之一,你都可以在我们的网站找到你想要的享受。'
     },
  },
  {
    path: '/review/:pid',
    name: 'Review',
    component: Review,
    meta: {   
        title:'西雅图桃桃私人会所-公主客评',
        keywords:'西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所',
        description:'西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所,西雅图桃桃私人会所是西雅图私人高级会所之一,你都可以在我们的网站找到你想要的享受。'
     },
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
 

export default router;